module.exports = __webpack_public_path__ + "img/icon-document.6e75ad01.svg";